import Vue from 'vue'
import Meta from 'vue-meta'
import Router from 'vue-router'

import securityRouter from './lib/securityRouter'
import callbackRouter from './lib/callbackRouter'
import authRouter from './lib/authRouter'
import initializeSegment from '../segment'

import configProvider from 'src/configProvider'

const config = configProvider.getConfig()

Vue.use(Router)
Vue.use(Meta)

export async function createRouter ({ store }) {
  const router = new Router({
    mode: 'history'
  })

  router.addRoutes([
    {
      path: '/',
      redirect: '/security'
    },
    ...securityRouter({ store, router }),
    ...callbackRouter({ store, router }),
    ...authRouter({ store, router }),
  ])

  if (config.segment) {
    initializeSegment(router, config.segment)
    if (window.analytics) {
      window.analytics.identify()
    }
  }

  if (config.pixel && config.pixel.id) {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', ${config.pixel.id});fbq('track', 'PageView');`
    document.body.appendChild(script)

    const noscript = document.createElement('noscript')
    noscript.innerHTML = `<img height="1" width="1"src="https://www.facebook.com/tr?id=${config.pixel.id}&ev=PageView &noscript=1"/>');`
    document.body.appendChild(noscript)
  }

  if (config.google && config.google.gtag) {
    var gaScript = document.createElement('script')
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${config.google.gtag.id}`
    gaScript.async = true

    var gtagScript = document.createElement('script')
    gtagScript.type = 'text/javascript'
    gtagScript.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${config.google.gtag.id}');`
    document.body.appendChild(gaScript)
    document.body.appendChild(gtagScript)
  }

  return router
}
